export default __webpack_public_path__ + "static/media/sales.f77fe773.png";